function baseUnary(r){return function(n){return r(n)}}module.exports=baseUnary;